import "./Header.scss";

const Header = () => {
  return (
    <header className="header">
      <h1>Trip Card Explorer</h1>
    </header>
  );
};

export default Header;
